/**
 * Hisab Okay Hai — Label Dictionary
 *
 * Single source of truth for all UI labels.
 * OFF = neutral English (default)
 * ON  = desi Hindi–Hinglish spoken tone
 *
 * Every label in the app must come from here via t('key').
 * No hardcoded text anywhere.
 */

const labels = {
  // ─── Transaction Types ───────────────────────────
  'transaction.expense_paid': {
    off: 'Expense (Paid)',
    on: 'Kharcha kiya',
  },
  'transaction.income_received': {
    off: 'Income (Received)',
    on: 'Payment aaya',
  },
  'transaction.payable': {
    off: 'Payable (Due)',
    on: 'Dena hai (Udhar)',
  },
  'transaction.receivable': {
    off: 'Receivable (Owed)',
    on: 'Udhar lena hai',
  },
  'transaction.scheduled': {
    off: 'Scheduled',
    on: 'Yaad dilana',
  },
  'transaction.income': {
    off: 'Income',
    on: 'Payment aaya',
  },
  'transaction.expense': {
    off: 'Expense',
    on: 'Kharcha kiya',
  },
  'transaction.self_transfer': {
    off: 'Transfer (Between Ledgers)',
    on: 'Khaton mein transfer',
  },

  // ─── Dashboard ───────────────────────────────────
  'dashboard.title': {
    off: 'Dashboard',
    on: 'Dashboard',
  },
  'dashboard.total_income': {
    off: 'Total Income',
    on: 'Saara payment aaya',
  },
  'dashboard.total_expense': {
    off: 'Total Expense',
    on: 'Saara kharcha kiya',
  },
  'dashboard.balance': {
    off: 'Available Balance',
    on: 'Abhi bacha hua',
  },
  'dashboard.upcoming_payables': {
    off: 'Upcoming Payables',
    on: 'Dena baaki hai',
  },
  'dashboard.receivables': {
    off: 'Receivables',
    on: 'Lena baaki hai',
  },
  'dashboard.payable': {
    off: 'Payable',
    on: 'Dena hai',
  },
  'dashboard.receivable': {
    off: 'Receivable',
    on: 'Lena hai',
  },
  'dashboard.your_ledgers': {
    off: 'Your Ledgers',
    on: 'Aapke khate',
  },
  'dashboard.recent_transactions': {
    off: 'Recent Transactions',
    on: 'Haal ke lenden',
  },
  'dashboard.upcoming_reminders': {
    off: 'Upcoming Reminders',
    on: 'Aane wali yaadein',
  },
  'dashboard.no_ledgers': {
    off: 'No ledgers yet',
    on: 'Koi khata nahi hai',
  },
  'dashboard.no_transactions': {
    off: 'No transactions yet',
    on: 'Koi lenden nahi hua',
  },
  'dashboard.no_reminders': {
    off: 'No upcoming reminders',
    on: 'Koi yaad nahi aani',
  },
  'dashboard.create_ledger_msg': {
    off: 'Create your first ledger to start tracking.',
    on: 'Pehla khata banao aur hisab shuru karo.',
  },
  'dashboard.add_transaction_msg': {
    off: 'Add your first transaction to see it here.',
    on: 'Pehla lenden jodo, yahan dikhega.',
  },
  'dashboard.all_caught_up': {
    off: "You're all caught up for now.",
    on: 'Abhi koi yaad nahi hai.',
  },

  // ─── Ledger Section ──────────────────────────────
  'ledger.title': {
    off: 'Ledgers',
    on: 'Khate',
  },
  'ledger.your_ledgers': {
    off: 'Your Ledgers',
    on: 'Aapke khate',
  },
  'ledger.add': {
    off: 'Add Ledger',
    on: 'Naya khata jodo',
  },
  'ledger.create': {
    off: 'Create Ledger',
    on: 'Khata banao',
  },
  'ledger.edit': {
    off: 'Edit Ledger',
    on: 'Khata badlo',
  },
  'ledger.name': {
    off: 'Ledger Name',
    on: 'Khate ka naam',
  },
  'ledger.balance': {
    off: 'Balance',
    on: 'Bacha hua',
  },
  'ledger.no_ledgers': {
    off: 'No ledgers yet',
    on: 'Koi khata nahi hai',
  },
  'ledger.create_first': {
    off: 'Create your first ledger to start tracking expenses.',
    on: 'Pehla khata banao, kharcha likhna shuru karo.',
  },
  'ledger.salary': {
    off: 'Salary Ledger',
    on: 'Salary khata',
  },
  'ledger.archive': {
    off: 'Archive',
    on: 'Band karo',
  },
  'ledger.unarchive': {
    off: 'Unarchive',
    on: 'Wapas kholo',
  },
  'ledger.delete_confirm': {
    off: 'This will permanently delete the ledger. If it has transactions, reminders, or transfers, you must archive it instead.',
    on: 'Ye khata pakka hat jayega. Agar isme lenden, yaadein, ya transfer hain, toh archive karo.',
  },

  // ─── Transactions ────────────────────────────────
  'transactions.title': {
    off: 'Transactions',
    on: 'Lenden',
  },
  'transactions.add': {
    off: 'Add Transaction',
    on: 'Naya lenden jodo',
  },
  'transactions.edit': {
    off: 'Edit Transaction',
    on: 'Lenden badlo',
  },
  'transactions.no_transactions': {
    off: 'No transactions yet',
    on: 'Koi lenden nahi hua',
  },
  'transactions.add_first_msg': {
    off: 'Add your first transaction to start tracking your income and expenses.',
    on: 'Pehla lenden jodo, aapka hisab yahan dikhega.',
  },
  'transactions.type': {
    off: 'Transaction Type',
    on: 'Lenden ka tarika',
  },
  'transactions.amount': {
    off: 'Amount',
    on: 'Raqam',
  },
  'transactions.date': {
    off: 'Date',
    on: 'Tareekh',
  },
  'transactions.description': {
    off: 'Description',
    on: 'Baat kya thi',
  },
  'transactions.notes': {
    off: 'Notes',
    on: 'Kuch aur likhna hai',
  },
  'transactions.category': {
    off: 'Category',
    on: 'Kisam',
  },
  'transactions.vendor': {
    off: 'Vendor',
    on: 'Dukandaar',
  },
  'transactions.ledger': {
    off: 'Ledger',
    on: 'Khata',
  },
  'transactions.locked_msg': {
    off: 'This transaction is locked (older than 24 hours)',
    on: '24 ghante purana hai, ab badal nahi sakte',
  },
  'transactions.select_category': {
    off: 'Select Category (Optional)',
    on: 'Kisam chuno (marzi)',
  },
  'transactions.no_ledger': {
    off: 'No Ledger',
    on: 'Bina khata',
  },
  'transactions.no_vendor': {
    off: 'No Vendor',
    on: 'Bina dukandaar',
  },
  'transactions.save': {
    off: 'Save Transaction',
    on: 'Lenden bachao',
  },
  'transactions.saving': {
    off: 'Saving...',
    on: 'Bacha rahe hai...',
  },
  'transactions.delete_confirm': {
    off: 'Are you sure you want to delete this transaction? This cannot be undone.',
    on: 'Pakka hatana hai? Ye wapas nahi aayega.',
  },
  'transactions.commitment_date': {
    off: 'Commitment Date (kab dena hai)',
    on: 'Kab dena hai',
  },
  'transactions.from_ledger': {
    off: 'From Ledger',
    on: 'Kis khate se',
  },
  'transactions.to_ledger': {
    off: 'To Ledger',
    on: 'Kis khate mein',
  },
  'transactions.select_source_ledger': {
    off: 'Select Source Ledger',
    on: 'Kis khate se nikalna hai',
  },
  'transactions.select_dest_ledger': {
    off: 'Select Destination Ledger',
    on: 'Kis khate mein daalna hai',
  },

  // ─── Budgets ─────────────────────────────────────
  'budgets.title': {
    off: 'Budgets',
    on: 'Budget',
  },
  'budgets.add': {
    off: 'Add Budget',
    on: 'Naya budget jodo',
  },
  'budgets.create': {
    off: 'Create Budget',
    on: 'Budget banao',
  },
  'budgets.no_budgets': {
    off: 'No budgets yet',
    on: 'Koi budget nahi hai',
  },
  'budgets.create_first_msg': {
    off: 'Create your first budget to start tracking your spending against goals.',
    on: 'Pehla budget banao, kharche pe nazar rakho.',
  },
  'budgets.spent': {
    off: 'spent',
    on: 'kharcha hua',
  },
  'budgets.budget': {
    off: 'budget',
    on: 'budget',
  },
  'budgets.remaining': {
    off: 'remaining',
    on: 'bacha hua',
  },
  'budgets.over_budget': {
    off: 'over budget',
    on: 'budget se zyada',
  },
  'budgets.edit': {
    off: 'Edit Budget',
    on: 'Budget badlo',
  },
  'budgets.name': {
    off: 'Budget Name',
    on: 'Budget ka naam',
  },
  'budgets.period': {
    off: 'Period',
    on: 'Samay',
  },
  'budgets.categories': {
    off: 'Categories',
    on: 'Kisam',
  },
  'budgets.start_date': {
    off: 'Start Date',
    on: 'Shuru ki tareekh',
  },
  'budgets.end_date': {
    off: 'End Date',
    on: 'Aakhri tareekh',
  },
  'budgets.all_ledgers': {
    off: 'All Ledgers',
    on: 'Saare khate',
  },
  'budgets.select_categories': {
    off: 'select one or more',
    on: 'ek ya zyada chuno',
  },
  'budgets.no_expense_categories': {
    off: 'No expense categories found',
    on: 'Koi kharche ki kisam nahi mili',
  },
  'budgets.selected': {
    off: 'selected',
    on: 'chune hue',
  },
  'budgets.delete': {
    off: 'Delete Budget',
    on: 'Budget hatao',
  },
  'budgets.delete_confirm': {
    off: 'Are you sure you want to delete this budget? This cannot be undone.',
    on: 'Pakka hatana hai? Ye wapas nahi aayega.',
  },

  // ─── Reminders ───────────────────────────────────
  'reminders.title': {
    off: 'Reminders',
    on: 'Yaadein',
  },
  'reminders.add': {
    off: 'Add Reminder',
    on: 'Naya yaad jodo',
  },
  'reminders.edit': {
    off: 'Edit Reminder',
    on: 'Yaad badlo',
  },
  'reminders.no_reminders': {
    off: 'No reminders yet',
    on: 'Koi yaad nahi hai',
  },
  'reminders.create_first_msg': {
    off: 'Create a reminder to never miss a payment or important date.',
    on: 'Yaad banao, koi payment ya tareekh mat bhoolo.',
  },
  'reminders.complete': {
    off: 'Complete',
    on: 'Poora hua',
  },
  'reminders.reminder_title': {
    off: 'Title',
    on: 'Naam',
  },
  'reminders.description': {
    off: 'Description',
    on: 'Kya hai',
  },
  'reminders.date': {
    off: 'Date',
    on: 'Tareekh',
  },
  'reminders.time': {
    off: 'Time',
    on: 'Waqt',
  },
  'reminders.repeat': {
    off: 'Repeat',
    on: 'Dobara',
  },
  'reminders.amount': {
    off: 'Amount',
    on: 'Raqam',
  },
  'reminders.delete': {
    off: 'Delete Reminder',
    on: 'Yaad hatao',
  },
  'reminders.delete_confirm': {
    off: 'Are you sure you want to delete this reminder? This cannot be undone.',
    on: 'Pakka hatana hai? Ye wapas nahi aayega.',
  },
  'reminders.select_ledger': {
    off: 'Select Ledger',
    on: 'Khata chuno',
  },

  // ─── Reports ─────────────────────────────────────
  'reports.title': {
    off: 'Reports',
    on: 'Hisab report',
  },
  'reports.monthly_summary': {
    off: 'Monthly Summary',
    on: 'Mahine ka hisab',
  },
  'reports.category_breakdown': {
    off: 'Category Breakdown',
    on: 'Kisam ke hisab se',
  },
  'reports.yearly_overview': {
    off: 'Yearly Overview',
    on: 'Saal ka hisab',
  },
  'reports.total_income': {
    off: 'Total Income',
    on: 'Saara payment aaya',
  },
  'reports.total_expense': {
    off: 'Total Expense',
    on: 'Saara kharcha kiya',
  },
  'reports.net_balance': {
    off: 'Net Balance',
    on: 'Bacha hua',
  },
  'reports.expense_by_category': {
    off: 'Expense by Category',
    on: 'Kisam ke hisab se kharcha',
  },
  'reports.no_monthly_data': {
    off: 'No data for this month',
    on: 'Is mahine ka koi hisab nahi',
  },
  'reports.add_txn_monthly_msg': {
    off: 'Add some transactions to see your monthly summary.',
    on: 'Kuch lenden jodo, mahine ka hisab dikhega.',
  },
  'reports.no_category_data': {
    off: 'No category data',
    on: 'Koi kisam ka hisab nahi',
  },
  'reports.add_categorized_msg': {
    off: 'Add categorized expenses to see the breakdown.',
    on: 'Kisam lagao kharche pe, breakdown dikhega.',
  },
  'reports.no_yearly_data': {
    off: 'No yearly data',
    on: 'Saal ka koi hisab nahi',
  },
  'reports.add_yearly_msg': {
    off: 'Add transactions throughout the year to see trends.',
    on: 'Saal bhar ke lenden jodo, trend dikhega.',
  },
  'reports.income_label': {
    off: 'Income',
    on: 'Aamad',
  },
  'reports.expense_label': {
    off: 'Expense',
    on: 'Kharcha',
  },

  // ─── Settings ────────────────────────────────────
  'settings.title': {
    off: 'Settings',
    on: 'Setting',
  },
  'settings.tone_label': {
    off: 'Hisab Okay Hai Tone',
    on: 'Hisab Okay Hai Tone',
  },

  // ─── Common Actions ──────────────────────────────
  'action.add': {
    off: 'Add',
    on: 'Jodo',
  },
  'action.save': {
    off: 'Save',
    on: 'Bacha lo',
  },
  'action.cancel': {
    off: 'Cancel',
    on: 'Rehne do',
  },
  'action.delete': {
    off: 'Delete',
    on: 'Hatao',
  },
  'action.edit': {
    off: 'Edit',
    on: 'Badlo',
  },
  'action.create': {
    off: 'Create',
    on: 'Banao',
  },
  'action.update': {
    off: 'Update',
    on: 'Badlo',
  },
  'action.confirm': {
    off: 'Confirm',
    on: 'Pakka karo',
  },
  'action.search': {
    off: 'Search',
    on: 'Dhundo',
  },
  'action.logout': {
    off: 'Logout',
    on: 'Bahar jao',
  },
  'action.login': {
    off: 'Login',
    on: 'Andar aao',
  },

  // ─── Common Labels ───────────────────────────────
  'common.loading': {
    off: 'Loading...',
    on: 'Ruko...',
  },
  'common.optional': {
    off: 'Optional',
    on: 'Marzi',
  },
  'common.required': {
    off: 'Required',
    on: 'Zaroori',
  },
  'common.select': {
    off: 'Select',
    on: 'Chuno',
  },
  'common.all': {
    off: 'All',
    on: 'Sab',
  },

  // ─── Categories ─────────────────────────────────
  'categories.title': {
    off: 'Categories',
    on: 'Kisam',
  },
  'categories.add': {
    off: 'Add Category',
    on: 'Naya kisam jodo',
  },
  'categories.create': {
    off: 'Create Category',
    on: 'Kisam banao',
  },
  'categories.edit': {
    off: 'Edit Category',
    on: 'Kisam badlo',
  },
  'categories.delete': {
    off: 'Delete Category',
    on: 'Kisam hatao',
  },
  'categories.delete_confirm': {
    off: 'Are you sure you want to delete this category? This cannot be undone.',
    on: 'Pakka hatana hai? Ye wapas nahi aayega.',
  },
  'categories.name': {
    off: 'Category Name',
    on: 'Kisam ka naam',
  },
  'categories.type': {
    off: 'Type',
    on: 'Tarika',
  },
  'categories.color': {
    off: 'Color',
    on: 'Rang',
  },
  'categories.icon': {
    off: 'Icon',
    on: 'Nishaan',
  },
  'categories.no_categories': {
    off: 'No categories yet',
    on: 'Koi kisam nahi hai',
  },
  'categories.create_first_msg': {
    off: 'Create categories to organize your transactions.',
    on: 'Kisam banao, lenden ko jagah do.',
  },
  'categories.no_bookmarks_msg': {
    off: 'No bookmarked categories. Star your favourites for quick access.',
    on: 'Koi bookmark nahi. Star lagao jaldi access ke liye.',
  },

  // ─── Navigation ─────────────────────────────────
  'nav.home': {
    off: 'Home',
    on: 'Ghar',
  },
  'nav.profile': {
    off: 'Profile',
    on: 'Profile',
  },

  // ─── Vendors ─────────────────────────────────────
  'vendors.title': {
    off: 'Vendors',
    on: 'Dukandaar',
  },
  'vendors.add': {
    off: 'Add Vendor',
    on: 'Naya dukandaar jodo',
  },
  'vendors.edit': {
    off: 'Edit Vendor',
    on: 'Dukandaar badlo',
  },
  'vendors.delete': {
    off: 'Delete Vendor',
    on: 'Dukandaar hatao',
  },
  'vendors.no_vendors': {
    off: 'No vendors yet',
    on: 'Koi dukandaar nahi',
  },
  'vendors.create_first_msg': {
    off: 'Add vendors to track payments and dues.',
    on: 'Dukandaar jodo, payment aur udhar track karo.',
  },
  'vendors.name': {
    off: 'Vendor Name',
    on: 'Dukandaar ka naam',
  },
  'vendors.phone': {
    off: 'Phone',
    on: 'Phone',
  },
  'vendors.notes': {
    off: 'Notes',
    on: 'Notes',
  },
  'vendors.delete_confirm': {
    off: 'Are you sure you want to delete this vendor? This cannot be undone.',
    on: 'Pakka hatana hai? Ye wapas nahi aayega.',
  },
  'vendors.transaction': {
    off: 'Vendor Transaction',
    on: 'Dukandaar ka Lenden',
  },
  'vendors.view_details': {
    off: 'View Details',
    on: 'Dekho',
  },
  'vendors.all_transactions': {
    off: 'All Transactions',
    on: 'Saare Lenden',
  },
  'vendors.total_income': {
    off: 'Total Income',
    on: 'Inse aaya',
  },
  'vendors.total_expense': {
    off: 'Total Expense',
    on: 'Inko diya',
  },
  'vendors.payables': {
    off: 'Payables',
    on: 'Dena baaki',
  },
  'vendors.receivables': {
    off: 'Receivables',
    on: 'Lena baaki',
  },
  'vendors.net_balance': {
    off: 'Net Balance',
    on: 'Net Hisab',
  },

  // ─── Ledger Detail ─────────────────────────────
  'ledger.view_details': {
    off: 'View Details',
    on: 'Dekho',
  },
  'ledger.all_transactions': {
    off: 'All Transactions',
    on: 'Saare Lenden',
  },
  'ledger.total_income': {
    off: 'Total Income',
    on: 'Saara aaya',
  },
  'ledger.total_expense': {
    off: 'Total Expense',
    on: 'Saara gaya',
  },
  'ledger.current_balance': {
    off: 'Current Balance',
    on: 'Bacha hua',
  },
};

export default labels;
